import { mapActions, mapState } from 'vuex';
import moment from 'moment';

export default {
	computed: {
		...mapState({
		})
	},
	methods: {
		helpers() {
			const callCenterPhoneNumber = (arg) => window.iframes.currentPhoneNumber;
				//if ((sessionStorage.getItem('utm_source') && sessionStorage.getItem('utm_source').toLowerCase() === 'fource') && (sessionStorage.getItem('utm_medium') && sessionStorage.getItem('utm_medium').toLowerCase() === 'omnichannel')) {
				//	return '855-505-3162';
				//}
				//return '855-442-4516';
			//};
			const formatterLongDate = (arg) => {
				let val = arg ? moment(arg).format('ddd. MMMM Do YYYY') : '';
				return val;
			};
			const formatterDayShorthand = (arg) => {
				let val = arg ? moment(arg, 'MM/DD/YYYY').format('D') : '';
				return val;
			};
			const formatterTime = (arg) => {
				let val = arg ? moment(arg).format('h:mm A') : '';
				return val;
			};
			return {
				callCenterPhoneNumber,
				formatterLongDate,
				formatterDayShorthand,
				formatterTime
			};
		},
		OnlineSchedulingHelpers() {
			return {
				buildCalendar(arg) {
					let _date = arg.date;
					let _start = moment(_date, 'MM/DD/YYYY').startOf('week').format('MM/DD/YYYY');
					return {
						year: moment(_date !== _start ? _date : _start, 'MM/DD/YYYY').format('YYYY'),
						month: moment(_date !== _start ? _date : _start, 'MM/DD/YYYY').format('MMMM'),
						week: [
							{
								title: 'SUN',
								date: _start,
								timeslots: [],
							},
							{
								title: 'MON',
								date: moment(_start, 'MM/DD/YYYY').add(1, 'days').format('MM/DD/YYYY'),
								timeslots: [],
							},
							{
								title: 'TUE',
								date: moment(_start, 'MM/DD/YYYY').add(2, 'days').format('MM/DD/YYYY'),
								timeslots: [],
							},
							{
								title: 'WED',
								date: moment(_start, 'MM/DD/YYYY').add(3, 'days').format('MM/DD/YYYY'),
								timeslots: [],
							},
							{
								title: 'THU',
								date: moment(_start, 'MM/DD/YYYY').add(4, 'days').format('MM/DD/YYYY'),
								timeslots: [],
							},
							{
								title: 'FRI',
								date: moment(_start, 'MM/DD/YYYY').add(5, 'days').format('MM/DD/YYYY'),
								timeslots: [],
							},
							{
								title: 'SAT',
								date: moment(_start, 'MM/DD/YYYY').add(6, 'days').format('MM/DD/YYYY'),
								timeslots: [],
							}
						]
					};
				}
			};
		}
	}
};
